module.exports = __webpack_public_path__ + "img/Technology.667b4f8b.png";